<template>
  <div>
    <v-row>
      <v-col 
        cols="12"
        md="12"
        class="py-0">
        <v-tabs
          v-model="selected.menu"
          grow
          slider-size="4"
          :color="set_color"
          :background-color="set_color_rgb_soft"
          style="border-radius: 8px 8px 0px 0px !important;">
          <v-tab
            v-for="(item, index) in menu"
            :key="index"
            @click="changeQuery(item.link)">
            <div
              class="text-capitalize"
              :class="selected.menu === index ? 'font-weight-bold' : ''">
              {{ item.text }}
            </div>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <div>
      <Keterlibatan v-if="selected.menu === 0" />

      <Pelatihan v-if="selected.menu === 1" />

      <Sertifikasi v-if="selected.menu === 2" />

      <!-- <Pengembangan v-if="selected.menu === 3" /> -->
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },

        menu: [
          {
            text: 'Keterlibatan Pegawai Dilingkungan Sekitar',
            link: '/evaluation/officer/additional?menu=0'
          },
          {
            text: 'Pelatihan Sertifikat',
            link: '/evaluation/officer/additional?menu=1'
          },
          {
            text: 'Sertifikasi Kompetensi',
            link: '/evaluation/officer/additional?menu=2'
          },
          // {
          //   text: 'Pengembangan Ekonomi',
          //   link: '/evaluation/officer/additional?menu=3'
          // }
        ],

        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Keterlibatan: () => import(/* webpackPrefetch: true */ '@/components/additional_task/keterlibatan_pegawai.vue'),
      Pelatihan: () => import(/* webpackPrefetch: true */ '@/components/additional_task/pelatihan_sertifikat.vue'),
      Sertifikasi: () => import(/* webpackPrefetch: true */ '@/components/additional_task/sertifikasi_kompetensi.vue'),
      // Pengembangan: () => import(/* webpackPrefetch: true */ '@/components/additional_task/pengembangan_ekonomi.vue'),
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.1)`
      }
    },
    watch: {
      
    },
    beforeMount () {
      this.changeLink(this.$route.query.menu)
    },
    mounted () {
      
    },
    methods: {
      changeLink (query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        if (query !== undefined) {
          this.selected.menu = parseInt(query)
        }
      },
      changeQuery (link) {
        this.$router.push(link)
      }
    }
  }
</script>